// Modules
import React from 'react';

// Components
import Button from './Button';

const MakePaymentButton = (props) => {
  const { clickHandler, isDisabled, buttonText = '' } = props;

  const handleClick = () => {
    if (isDisabled) return;

    clickHandler();
  };

  return (
    <Button
      text={buttonText ? buttonText : 'Make payment \u2192'}
      clickHandler={handleClick}
      isDisabled={isDisabled}
      extraStyles={{ width: '100%', paddingTop: '20px', paddingBottom: '20px' }}
    />
  );
};

export default MakePaymentButton;
